<template>

    <div class="d-flex flex-column justify-content-between" style="min-height: 100vh">

        <div class="search-bar-webshop">
            <div class="container search-bar-bottom">
                <div class="row py-3 align-items-center">
                    <div class="col-12">
                        <p style="font-family: Poppins, sans-serif;font-size: 16px;margin-top:0px;margin-bottom:0px;color: #ffffff;font-size: 17px;text-align:center;-webkit-font-smoothing: antialiased;font-smoothing: antialiased;font-weight: 300;">{{ translations.Ben_jij_een_professional_1 }} <a href="https://store.kanters.be/bestelplatform/login" style="color:#ffffff;text-decoration: underline;text-underline-position: under;">{{ translations.Ben_jij_een_professional_2 }}</a> {{ translations.Ben_jij_een_professional_3 }}</p>
                    </div>
                </div>
            </div>
        </div>

        <header>
            <div class="container px-2">
                <div class="navbar px-0">
                <div class="row align-items-center justify-content-between w-100">
                    <div class="col-7 text-center text-lg-left col-lg-4 pr-0">
                        <a class="navbar-brand" href="https://www.kanters.be">
                            <img src="/img/logo-svg-kanters.svg" alt="Kanters Haar- en Nagelstyling">
                        </a>
                    </div>
                    <div class="col-5 col-lg-8 pr-0">
                        <div class="tm-header-mobile d-lg-none">

                            <div  show-on-up="" style="">

                                <div class="uk-navbar-container">
                                    <nav uk-navbar="" class="uk-navbar">




                                        <div class="uk-navbar-right">


                                            <ul class="navbar-nav flex-row justify-content-end text-center mt-0">

                                                <li class="nav-item col-auto pr-0" style="position: relative;top: -1px;">
                                                    <a :href="locale === 'fr' ? '/bestelplatform/login' : '/bestelplatform/login'" class="nav-link d-inline-block  w-auto" style="background-color: #51507A;color: #FFF;padding: 8px 14px;box-sizing: border-box;">
                                                        <span uk-icon="user" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.9" cy="6.4" r="4.4"></circle><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"></path></svg></span>
<!--                                                        {{ translations.Login }}-->
                                                    </a>
                                                </li>

                                                <li class="nav-item col-auto pr-0">
                                                    <router-link :to="{ name: 'cart', }" class="nav-link mini-cart-link" style="font-size: 1.5rem;background-color: #51507A;color: #FFF;padding: 5px 11px;box-sizing: border-box;">
<!--                                                        <i class="fal fa-shopping-cart" style="font-size: 1.5rem"></i>-->
                                                        <span uk-icon="bag" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M7.5,7.5V4A2.48,2.48,0,0,1,10,1.5,2.54,2.54,0,0,1,12.5,4V7.5"></path><polygon fill="none" stroke="#000" points="16.5 7.5 3.5 7.5 2.5 18.5 17.5 18.5 16.5 7.5"></polygon></svg></span>
                                                        <small v-if="$store.getters.count > 0" class="badge badge-pill badge-dark">{{ $store.getters.count}}</small>
                                                    </router-link>

                                                </li>
<!--                                                <li class="nav-item col-auto pr-0 d-none d-lg-block">
&lt;!&ndash;                                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Frans">&ndash;&gt;
                                                    <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Frans" style="width: 20px;">
                                                </li>-->

                                                <li v-if="$route.params.locale !== 'nl'"  class="nav-item col-auto pr-0 d-lg-none" >
                                                    <a :href="$router.resolve({  params: { locale: 'nl'} }).href" class="nav-link mini-cart-link">
                                                        <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/nl.png" alt="Nederlands">-->
                                                        <img class="wpml-ls-flag" src="/img/nl-026-location.svg" alt="Nederlands" style="width: 20px;">
                                                    </a>
                                                </li>
                                                <li v-if="$route.params.locale !== 'fr'" class="nav-item col-auto pr-0 d-lg-none" >
                                                    <a :href="$router.resolve({  params: { locale: 'fr'} }).href" class="nav-link mini-cart-link">
                                                        <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Nederlands">-->
                                                        <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Francais" style="width: 20px;">
                                                    </a>
                                                </li>

                                            </ul>

                                            <a class="uk-navbar-toggle" href="#tm-mobile" uk-toggle="animation: true" aria-expanded="false">
                                                <div uk-navbar-toggle-icon="" class="uk-icon uk-navbar-toggle-icon"><svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><rect y="9" width="20" height="2"></rect><rect y="3" width="20" height="2"></rect><rect y="15" width="20" height="2"></rect></svg></div>
                                            </a>

                                        </div>

                                    </nav>
                                </div>







                            </div><div class="uk-sticky-placeholder" style="height: 100px; margin: 0px;" hidden=""></div>


                        </div>
                        <ul class="navbar-nav flex-row justify-content-end text-center row d-none d-lg-block">

                            <li v-for="(menuItem, index) in websiteMenuItems" class="nav-item col-auto"  :class="'item-'+menuItem.ID" v-if="index !== 5">
                                <a :href="menuItem.url" v-html="menuItem.title" :target="menuItem.target" class="nav-link d-inline-block w-auto">

                                </a>
                            </li>

                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/a-propos-de-nous/' : 'https://www.kanters.be/over-ons'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Over_Kanters }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/formation/' : 'https://www.kanters.be/opleiding'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Opleiding }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/nouvelles/' : 'https://www.kanters.be/blogs-nieuws'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Nieuws }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/contact/' : 'https://www.kanters.be/contact'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Contact }}
                                </a>
                            </li>


                            <li class="nav-item col-auto" style="position: relative;top: -1px;">
                                <a :href="locale === 'fr' ? '/bestelplatform/login' : '/bestelplatform/login'" class="nav-link d-inline-block  w-auto" style="background-color: #51507A;color: #FFF;padding: 8px 14px;box-sizing: border-box;">
                                    <span uk-icon="user" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.9" cy="6.4" r="4.4"></circle><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"></path></svg></span>
                                    {{ translations.Login }}
                                </a>
                            </li>



<!--                            <li class="nav-item col-auto">
                                <a :href="$router.resolve({ name: 'home-loc', params: {locale: $route.params.locale }}).href" class="nav-link d-inline-block  w-auto">
                                    Webshop
                                </a>
                            </li>-->

<!--                            <li class="nav-item col-auto pr-0" v-if="window._locale == 'nl'">-->
<!--                                <router-link :to="{ locale: 'fr', }" class="nav-link mini-cart-link">-->
<!--                                <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Frans">-->
<!--                                </router-link>-->
<!--                            </li>-->
                            <li class="nav-item col-auto pr-0">
                                <router-link :to="{ name: 'cart', }" class="nav-link mini-cart-link" style="font-size: 1.5rem;background-color: #51507A;color: #FFF;padding: 5px 11px;box-sizing: border-box;">
<!--                                    <i class="fal fa-shopping-cart" style="font-size: 1.5rem;background-color: #51507A;color: #FFF;padding: 8px 14px;box-sizing: border-box;"></i>-->
                                    <span uk-icon="bag" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M7.5,7.5V4A2.48,2.48,0,0,1,10,1.5,2.54,2.54,0,0,1,12.5,4V7.5"></path><polygon fill="none" stroke="#000" points="16.5 7.5 3.5 7.5 2.5 18.5 17.5 18.5 16.5 7.5"></polygon></svg></span>
                                    <small v-if="$store.getters.count > 0" class="badge badge-pill badge-dark">{{ $store.getters.count}}</small>
                                </router-link>

                            </li>
                            <li v-if="$route.params.locale !== 'nl'"  class="nav-item col-auto pr-0" >
                                <a :href="$router.resolve({  params: { locale: 'nl'} }).href" class="nav-link mini-cart-link">
<!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/nl.png" alt="Nederlands">-->
                                    <img class="wpml-ls-flag" src="/img/nl-026-location.svg" alt="Nederlands" style="width: 20px;">
                                </a>
                            </li>
                            <li v-if="$route.params.locale !== 'fr'" class="nav-item col-auto pr-0" >
                                <a :href="$router.resolve({  params: { locale: 'fr'} }).href" class="nav-link mini-cart-link">
<!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Nederlands">-->
                                    <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Francais" style="width: 20px;">
                                </a>
                            </li>


                        </ul>
                    </div>

                </div>

                </div>
<!--                <div class="row py-1">-->
<!--                    <div class="col-12 text-center header-title">-->
<!--                        <h1>{{ $root.title }}</h1>-->
<!--                    </div>-->
<!--                </div>-->
            </div>

        </header>
        <div id="tm-mobile" class="" hidden="">
            <div class="uk-background-default uk-padding uk-text-center">


                <div class="uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">    <div>
                    <div class="uk-panel">



                        <ul class="uk-nav uk-nav-default uk-nav-center">

                            <li v-for="(menuItem, index) in websiteMenuItems" class="nav-item col-auto" :class="'item-'+menuItem.ID" v-if="index !== 5">
                                <a :href="menuItem.url"  v-html="menuItem.title" class="nav-link d-inline-block w-auto">
                                </a>
                            </li>


                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/a-propos-de-nous/' : 'https://www.kanters.be/over-ons'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Over_Kanters }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/formation/' : 'https://www.kanters.be/opleiding'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Opleiding }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/nouvelles/' : 'https://www.kanters.be/blogs-nieuws'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Nieuws }}
                                </a>
                            </li>
                            <li class="nav-item col-auto">
                                <a :href="locale === 'fr' ? 'https://www.kanters.be/fr/contact/' : 'https://www.kanters.be/contact'" class="nav-link d-inline-block  w-auto">
                                    {{ translations.Contact }}
                                </a>
                            </li>



                            <li class="nav-item col-auto" style="position: relative;top: -1px;">
                                <a :href="locale === 'fr' ? '/bestelplatform/login' : '/bestelplatform/login'" class="nav-link d-inline-block  w-auto" style="background-color: #51507A;color: #FFF !important;padding: 8px 14px;box-sizing: border-box;">
                                    <span uk-icon="user" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.9" cy="6.4" r="4.4"></circle><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"></path></svg></span>
                                    {{ translations.Login }}
                                </a>
                            </li>



                            <li class="nav-item col-auto">
                                <router-link :to="{ name: 'cart', }" class="nav-link mini-cart-link" style="font-size: 1.5rem;background-color: #51507A;color: #FFF !important;padding: 5px 11px;box-sizing: border-box;">
                                    <!--                                    <i class="fal fa-shopping-cart" style="font-size: 1.5rem;background-color: #51507A;color: #FFF;padding: 8px 14px;box-sizing: border-box;"></i>-->
                                    <span uk-icon="bag" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M7.5,7.5V4A2.48,2.48,0,0,1,10,1.5,2.54,2.54,0,0,1,12.5,4V7.5"></path><polygon fill="none" stroke="#000" points="16.5 7.5 3.5 7.5 2.5 18.5 17.5 18.5 16.5 7.5"></polygon></svg></span> Winkelmandje
                                    <small v-if="$store.getters.count > 0" class="badge badge-pill badge-dark">{{ $store.getters.count}}</small>
                                </router-link>

                            </li>
                            <li v-if="$route.params.locale !== 'nl'"  class="nav-item col-auto" >
                                <a :href="$router.resolve({  params: { locale: 'nl'} }).href" class="nav-link mini-cart-link">
                                    <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/nl.png" alt="Nederlands">-->
                                    <img class="wpml-ls-flag" src="/img/nl-026-location.svg" alt="Nederlands" style="width: 20px;">
                                </a>
                            </li>
                            <li v-if="$route.params.locale !== 'fr'" class="nav-item col-auto" >
                                <a :href="$router.resolve({  params: { locale: 'fr'} }).href" class="nav-link mini-cart-link">
                                    <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Nederlands">-->
                                    <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Francais" style="width: 20px;">
                                </a>
                            </li>






                            <!--                            <li class="nav-item col-auto">
                                                            <router-link :to="{ name: 'home', }" class="nav-link d-inline-block  w-auto">
                                                                Webshop
                                                            </router-link>
                                                        </li>-->
<!--                            <li class="nav-item col-auto   d-lg-none">
&lt;!&ndash;                                <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Frans">&ndash;&gt;
                                <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Frans" style="width: 20px;">
                            </li>-->
                        </ul>
                    </div>
                </div></div>
            </div>
        </div>

            <transition name="slide" mode="out-in"  @beforeLeave="fadeBeforeLeave"
                        @enter="fadeEnter"
                        @afterEnter="fadeAfterEnter">
                <router-view></router-view>
            </transition>


        <footer class="footer">
            <div class="uk-container">

                <div class="tm-grid-expand uk-grid-margin uk-grid" uk-grid="">
                    <div class="uk-grid-item-match uk-flex-middle uk-width-1-2@m uk-first-column">



                        <div class="uk-panel uk-width-1-1">
                            <div class="uk-panel uk-margin"><h2>{{ __('webshop.Onze openingsuren') }}</h2>
                                <p>{{ __('webshop.Ma - Vrij: 09u00 - 17u30' ) }}<br>
                                    {{ __('webshop.Zaterdag en zondag gesloten' ) }}</p>

                                <ul style="text-align: left;">
                                    <li v-if="$route.params.locale !== 'nl'"  class="nav-item col-auto pr-0 pl-0" >
                                        <a :href="$router.resolve({  params: { locale: 'nl'} }).href" class="nav-link mini-cart-link">
                                            <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/nl.png" alt="Nederlands">-->
                                            <img class="wpml-ls-flag" src="/img/nl-026-location.svg" alt="Nederlands" style="width: 20px;">
                                        </a>
                                    </li>
                                    <li v-if="$route.params.locale !== 'fr'" class="nav-item col-auto pr-0 pl-0" >
                                        <a :href="$router.resolve({  params: { locale: 'fr'} }).href" class="nav-link mini-cart-link">
                                            <!--                                    <img class="wpml-ls-flag" src="https://www.kanters.be/wp-content/plugins/sitepress-multilingual-cms/res/flags/fr.png" alt="Nederlands">-->
                                            <img class="wpml-ls-flag" src="/img/fr-037-location.svg" alt="Francais" style="width: 20px;">
                                        </a>
                                    </li>

                                </ul>

                            </div>
                        </div>



                    </div>

                    <div class="uk-grid-item-match uk-flex-middle uk-width-1-2@m">



                        <div class="uk-panel uk-width-1-1">
                            <div class="uk-panel uk-margin"><ul class="footer-left">
                                <li>Fabriekstraat 104C | 3900 Pelt</li>
                                <li><a href="tel:+3211641289">011/64 12 89</a></li>
                                <li><a href="mailto:info@kanters.be">info@kanters.be</a></li>
                                <li>BE0473 231 821</li>
                            </ul></div><div class="uk-panel uk-margin"><ul class="footer-right">
                            <li><a href="https://kanters.be/algemene-voorwaarden/">{{ __('webshop.Algemene voorwaarden') }}</a></li>
                            <li><a href="https://kanters.be/levertijden-en-verzendkosten/">{{ __('webshop.Levertijden en verzendkosten') }}</a></li>
                            <li><a href="https://kanters.be/retourneren/">{{ __('webshop.Retourneren') }}</a></li>
                        </ul></div><div class="uk-panel uk-margin"><ul class="footer-right" style="top: -20px;">
<!--                            <li>&copy; {{ \Carbon\Carbon::now()->year }}</li>-->
                            <li>&copy; {{ year }}</li>
                            <li><a href="https://kanters.be//disclaimer/">{{ __('webshop.Disclaimer')  }}</a></li>
                            <li><a href="https://kanters.be//privacy-policy/">{{ __('webshop.Privacy Policy') }}</a></li>
                            <li><a href="https://www.creatic.com" target="_blank" rel="noopener">Creatic.Agency</a></li>
                        </ul></div>
                        </div>



                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
export default {
    data() {
        return {
            prevHeight: 0,
            title: '',
            websiteMenuItems: [],
            locale: document.querySelector('meta[name="locale"]').getAttribute('content'),
            translations: window.translations,
            year: new Date().getFullYear(),
        }
    },
    beforeMount() {
        this.loadWebsiteMenu();
    },
    methods: {
        fadeBeforeLeave(element) {
            this.prevHeight = getComputedStyle(element).height;
        },
        fadeEnter(element) {
            window.scrollTo({top: 0,left: 0});
            const {height} = getComputedStyle(element);

            element.style.height = "100vh";

            setTimeout(() => {
                element.style.height = height;
            });
        },
        fadeAfterEnter(element) {
            element.style.height = 'auto';
        },
        loadWebsiteMenu() {
            this.$http.get(this.api_url("/wp/menu") + '?locale=' + window._locale)
            .then((response) => {
                //context.commit("products",response.data.products) //categories will be run from mutation
               this.websiteMenuItems = response.data


            })
        }
    }
}
</script>
<style>
.footer ul > li,
.footer ul > li > a{
    font-family: Poppins, sans-serif;
    font-style: normal;
    letter-spacing: normal;
    font-size: .875rem;
    line-height: 18px;
    color: #323158 !important;
    font-weight: 300;
}
.footer ul {
    text-align: right;
    list-style-type: none;
    padding-left: 0;
    display: block;
}
.footer-right{top:-12px;position: relative;     color: #695446 !important;}
.footer h2{    color: #3e1b37 !important; font-size: 30px;margin-bottom:0;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.2;
    font-family: Playfair Display, sans-serif;
    text-transform: none;
    letter-spacing: normal;
    font-style: normal;

    @media (max-width: 959px) {
        font-size: 24px;
    }

}
.footer p{margin-top:15px;font-family: Poppins, sans-serif;font-size: 16px;color: #323158;font-weight: 300;line-height: 1.5;font-style: normal;}
.footer {
    background-color: #dcd5e480 !important;
    color: #695446 !important;
    padding-top: 24px;
    padding-bottom: 24px;

}
footer ul>li{display: inline-block}
footer ul>li:not(:last-child):after{content:'|';margin-left:5px;margin-right:5px;}

@media(min-width: 959px){
    .footer > div {
        max-width: 1410px;
        margin: 0 auto;
    }
    .footer {
        padding-top: 48px;
        padding-bottom: 48px;
    }
}
@media(max-width:959px){
    .footer{padding-top:40px;padding-bottom:40px;}
    .footer ul {text-align: center}
    .footer>div>div>div:nth-child(1)>div{text-align: center}
}
@media(max-width: 620px){
    .footer ul>li{display:block;     color: #695446 !important;}
    .footer ul>li:after{display: none}
    .footer-right{margin-top:20px;}
}
.uk-navbar-container:not(.uk-navbar-transparent) {
    background: #fff;
}
.uk-navbar-toggle-icon > svg {color: #2d2b2b;}

.uk-nav-default>li>a {
    color: #2d2b2b !important;
    font-weight: 600 !important;
    font-style: normal !important;
    font-size: 15px !important;
    line-height: 22px !important;
    text-transform: uppercase !important;
}

.uk-nav-default>li>a:hover,
.uk-nav-default>li>a:focus {
    color: #695446 !important;
}

.uk-nav-default>li.uk-active>a {
    color: #695446 !important;
}

.uk-navbar-nav>li>a{
    color: #2d2b2b;
    font-family: var(--font);
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    text-transform: uppercase;
    line-height: normal;
}

.uk-navbar-container {
    position: relative;
    z-index: 5;
}


@media (max-width: 1030px) {
    .tm-header.uk-visible\@m { display: none !important; }
    .tm-header-mobile.uk-hidden\@m { display: block !important; }
    .tm-toolbar,.page-header,.uk-subnav {display: none;}
    .uk-logo img {max-height: 70px;}
    .home-header > div {height: 300px;}
    .home-header:after{display: none;}
    #tm-mobile > div {
        box-shadow: 0 10px 10px 0px rgba(0,0,0,0.05);
    }
    .uk-navbar-item, .uk-navbar-nav>li>a, .uk-navbar-toggle {min-height: 100px;}
}

</style>
